export default function BlogHero() {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6">
          <a 
            href="/blog" 
            className="inline-flex items-center text-teal-600 hover:text-teal-700 font-medium cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Back to Blog
          </a>
        </div>
        
        <div className="mb-6">
          <span className="px-4 py-2 bg-teal-500 text-white text-sm font-semibold rounded-full whitespace-nowrap">
            Efficiency
          </span>
        </div>
        
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight">
          Shortening the Lead Time: How Professional Layouts Speed Up Project Timelines
        </h1>
        
        <div className="flex items-center space-x-6 text-gray-600 mb-8">
          <div className="flex items-center">
            <i className="ri-calendar-line mr-2"></i>
            <span>March 2024</span>
          </div>
          <div className="flex items-center">
            <i className="ri-time-line mr-2"></i>
            <span>5 min read</span>
          </div>
        </div>
        
        <div className="relative h-96 w-full rounded-2xl overflow-hidden shadow-2xl">
          <img 
            src="https://public.readdy.ai/ai/img_res/1fd1accd6f8c38e8c15740cdfd3b4a29.jpg"
            alt="Efficient construction crew working with professional layouts"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}
